import { render, staticRenderFns } from "./card3.vue?vue&type=template&id=0147424f&scoped=true&"
import script from "./card3.vue?vue&type=script&lang=js&"
export * from "./card3.vue?vue&type=script&lang=js&"
import style0 from "./card3.vue?vue&type=style&index=0&id=0147424f&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0147424f",
  null
  
)

export default component.exports